import { Component } from '@angular/core';
import { PricePlanButtonsComponent } from '../price-plan/buttons/buttons.component';
import { PackagePlan } from '../../model/PackagePlan';
import { PackagePlanServiceService } from '../service/package-plan-service.service';
import { HeaderComponent } from "./header/header.component";
import { Router } from '@angular/router';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NewPurchaseFormTsService } from '../service/new-purchase-form.ts.service';
import { UserService } from '../service/user.service';
import { DashboardComponent } from '../user-area/dashboard/dashboard.component';


@Component({
  selector: 'app-main',
  standalone: true,
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
  imports: [CommonModule, ReactiveFormsModule, PricePlanButtonsComponent, HeaderComponent, DashboardComponent]
})
export class MainComponent {
  packagePlans: PackagePlan[] = [];

  form = new FormGroup({
    productId: new FormControl(''),
    productName: new FormControl('', Validators.required),
    productPriceCurrency: new FormControl('USD', Validators.required),
    productPrice: new FormControl(0, Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    nip: new FormControl(''),
    street: new FormControl('', Validators.required),
    zip: new FormControl('', Validators.required),
    city: new FormControl('', Validators.required),
    confirmation: new FormControl('', Validators.required)
  });

  constructor(
    private readonly router: Router,
    private readonly packagePlanService: PackagePlanServiceService,
    private readonly newPurchaseFormTsService: NewPurchaseFormTsService,
    private readonly userService: UserService
  ) {
    console.log('loading main.component');
    packagePlanService.getPackagePlans().then((plans) => {
      this.packagePlans = plans;
      console.log(`Fetched ${plans.length} package plans`);
    }).catch((error) => {
      console.error('Error fetching package plans', error);
    });
  }

  getPrivatePackagePlans(): void {
    console.log('called: getPrivatePackagePlans');
    this.packagePlanService.getPackagePlans().then((plans) => {
      this.packagePlans = plans;
      console.log(`Fetched ${plans.length} package plans`);
    }).catch((error) => {
      console.error('Error fetching package plans', error);
    });
  }

  isUserLoggedIn(): boolean {
    return this.userService.isUserLoggedIn();
  }

  filterPlans(fromIndex: number, toIndex: number): PackagePlan[] {
    return this.packagePlans.filter((_, index) => index >= fromIndex && index < toIndex);
  }

  selectPackagePlan(plan: PackagePlan): void {
    console.log(`Selected plan ${plan.name}`);
    this.form.controls['productId'].setValue(plan.id);
    this.form.controls['productName'].setValue(plan.name);
    this.form.controls['productPrice'].setValue(plan.priceUSD);
    this.form.controls['productPriceCurrency'].setValue('USD');
  }

  onSubmit(): void {
    console.log(`form: ${JSON.stringify(this.form.value, null, 2)}`);
    this.newPurchaseFormTsService.updateData(this.form.value);
    this.router.navigate(['/register']);
  }

}
